import axios from 'axios'
import { constants as C } from './constants'

export const fetchNews = () => {
    return axios.get(C.NEWS_ENDPOINT)
}